import { TipoDocumentoPertencer } from 'enuns/TipoArquivoPertencer';

export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result as string;
      const encode = result.split('base64,')[1];
      resolve(encode);
    };
    reader.onerror = error => reject(error);
  });

export const isWordFile = (fileName: string) => {
  const extensions = ['doc', 'docx'];
  return extensions.some(ext => fileName.endsWith(ext));
};

export const isPdfFile = (fileName: string) => {
  return fileName.endsWith('pdf');
};

export const isValidImage = (fileName: string) => {
  const extensions = ['jpg', 'jpeg', 'png'];
  return extensions.some(ext => fileName.endsWith(ext));
};

export const isValidPertencerFile = (fileName: string) => {
  const name = fileName.toLocaleLowerCase();
  return isWordFile(name) || isPdfFile(name) || isValidImage(name);
};

export const tipoPertencer = (fileName: string): TipoDocumentoPertencer => {
  const name = fileName.toLowerCase();
  if (isWordFile(name)) return TipoDocumentoPertencer.edital;
  if (isPdfFile(name)) return TipoDocumentoPertencer.atas;
  if (isValidImage(name)) return TipoDocumentoPertencer.fotos;
  return TipoDocumentoPertencer.desconhecido;
};

export const isValidFileSize = (fileSize: number, limitInMb: number) => {
  const limitInBytes = limitInMb * 1024 * 1024;
  return fileSize <= limitInBytes;
};

export const isValidFileName = (fileName: string, limitChars: number) => {
  return fileName.length <= limitChars;
};
